import { Provider } from "react-redux";
import { BrowserRouter, RouterProvider } from "react-router-dom";
import routes from "./views/routes";
import { store } from "./redux/store";
import MaterialTheme from "./views/components/MaterialTheme";
import SWRconfig from "./views/components/SWRconfig";

const App = () => {
  return (
    <Provider store={store}>
      <MaterialTheme>
        <SWRconfig>
          <RouterProvider router={routes} />
        </SWRconfig>
      </MaterialTheme>
    </Provider>
  );
};

export default App;
